import React from 'react'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { Alert } from '@winnin/winnin_ui.components.alert'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import Error from 'components/Error'
import { T, useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import './index.scss'

const RENEWAL_DATE = dayjs().add(1, 'month').startOf('month').format('DD/MM/YYYY')

const TOLGEE_PREFIX = 'GenerateWinninAIReportModal-AvailableReports'

export default function AvailableReports({ loading, error, refetch, totalZaiReportsAvailable }) {
  const t = useTranslate()
  const isZaiReportsNotAvailable = totalZaiReportsAvailable <= 0

  if (error) {
    return (
      <Error
        errorMessage={t(TOLGEE_GLOBALS.errorTextHeader)}
        handleError={refetch}
        buttonText={t(TOLGEE_GLOBALS.tryAgain)}
      />
    )
  }

  if (loading) {
    return (
      <div
        className={classNames('AvailableReports-loadingWrapper', {
          'AvailableReports-loadingWrapper-notEnough': isZaiReportsNotAvailable,
        })}
      >
        <Loading />
      </div>
    )
  }

  return (
    <div className="AvailableReports">
      <div className="AvailableReports-content">
        <p className="AvailableReports-text">
          <T
            keyName={`${TOLGEE_PREFIX}-text`}
            parameters={{
              total: isZaiReportsNotAvailable ? 0 : totalZaiReportsAvailable,
              span: (
                <span
                  className={classNames('AvailableReports-text-reports', {
                    'AvailableReports-text-reports-notEnough': isZaiReportsNotAvailable,
                  })}
                />
              ),
            }}
          >
            {`Você possui <span>{total} AI Reports disponíveis</span> neste mês`}
          </T>
          <TooltipWrapper
            tooltipMessage={t({
              key: `${TOLGEE_PREFIX}-tooltipMessage`,
              defaultValue:
                'O limite de AI Reports é contabilizado por Workspace e será renovado todo dia primeiro do mês',
            })}
            isTooltipMultiline
            tooltipStyle="tooltippedS"
            className="AvailableReports-tooltip"
          >
            <Icon icon="questionMark" fill="var(--color_neutral_800)" />
          </TooltipWrapper>
        </p>
        <span className="AvailableReports-text-renewal">
          <T keyName={`${TOLGEE_PREFIX}-renewal`} parameters={{ renewalDate: RENEWAL_DATE }}>
            {'Renovação em {renewalDate}'}
          </T>
        </span>
      </div>
      {isZaiReportsNotAvailable && (
        <Alert
          message={t({
            key: `${TOLGEE_PREFIX}-alertMessage`,
            defaultValue:
              'Entre em contato com seu CSM para para receber AI Reports adicionais neste Workspace antes do prazo de renovação.',
          })}
          variation="info"
        />
      )}
    </div>
  )
}
